import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Default theme is `dark` on <html> in index.html; `DocumentThemeSync` switches to light on /login and /signup only.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);
